<template>
  <div>
    <v-toolbar :dark="true">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="confirmBattery(createdBattery)" :loading="waiting">
            <v-icon>done_all</v-icon>
          </v-btn>
        </template>
        <span>Finalize Battery</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" v-exporttocsv="'#createdbattery'">
            <v-icon>save</v-icon>
          </v-btn>
        </template>
        <span>Download All Details</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" v-exporttocsv="'#sortedcells'">
            <v-icon>format_list_numbered</v-icon>
          </v-btn>
        </template>
        <span>Download Cell List</span>
      </v-tooltip>
    </v-toolbar>
    <div style="display: none">
      <v-simple-table id="sortedcells">
        <template v-slot:default>
          <thead>
          </thead>
          <tbody>
            <tr>
              <th colspan="4" style="text-align: center">{{today}}</th>
            </tr>
            <tr>
              <th colspan="4" style="text-align: center"></th>
            </tr>
            <tr>
              <th colspan="4" style="text-align: center">Battery Number #{{batteryNumber}}</th>
            </tr>
            <tr>
              <th colspan="4" style="text-align: center"></th>
            </tr>
            <tr>
              <th>Cells List</th>
              <th> </th>
              <th>Cell 1</th>
              <th>Cell 2</th>
            </tr>
            <tr v-for="(battery, i) in sortedCells" :key="`sorted-cells-${i}`">
              <td>{{battery}}</td>
              <td> </td>
              <td v-if="createdBattery[i]">{{createdBattery[i].cells[0].number}}</td>
              <td v-else></td>
              <td v-if="createdBattery[i]">{{createdBattery[i].cells[1].number}}</td>
              <td v-else></td>
            </tr>
            <tr>
              <td colspan="4"> </td>
            </tr>
            <tr>
              <th> </th>
              <th>Max</th>
              <th>Min</th>
              <th> </th>
            </tr>
            <tr v-for="(battery, i) in batteryStrength" :key="`sorted-meta-${i}`">
              <td>{{battery.name}}</td>
              <td>{{battery.max}}</td>
              <td>{{battery.min}}</td>
              <td></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

    </div>
    <v-simple-table id="createdbattery">
      <template v-slot:default>
        <thead>
          <tr>
            <th>#</th>
            <th>Value</th>
            <th>Power</th>
            <th>Power / Value</th>
            <th>#</th>
            <th>Value</th>
            <th>Power</th>
            <th>Power / Value</th>
            <th>Total Power / Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="9" style="text-align: center">{{new Date().toDateString()}}</td>
          </tr>
          <tr>
              <th colspan="9" style="text-align: center">Battery Number #{{batteryNumber}}</th>
          </tr>
          <tr>
            <td colspan="9" style="text-align: center">{{userWarranty}}</td>
          </tr>
          <tr v-for="(battery, i) in createdBattery" :key="i">
            <td>{{battery.cells[0].number}}</td>
            <td>{{battery.cells[0].value}}</td>
            <td>{{battery.cells[0].power}}</td>
            <td>{{battery.cells[0].voltage}}</td>
            <td>{{battery.cells[1].number}}</td>
            <td>{{battery.cells[1].value}}</td>
            <td>{{battery.cells[1].power}}</td>
            <td>{{battery.cells[1].voltage}}</td>
            <td>{{battery.voltage}}</td>
          </tr>
          <tr>
            <td colspan="9"> </td>
          </tr>
          <tr>
            <td colspan="9"> </td>
          </tr>
          <tr>
            <th colspan="2"> </th>
            <th colspan="2">Max</th>
            <th colspan="2">Min</th>
            <th colspan="2">Difference</th>
            <th> </th>
          </tr>
          <tr v-for="(battery, i) in batteryStrength" :key="`meta-${i}`">
            <td colspan="2">{{battery.name}}</td>
            <td colspan="2">{{battery.max}}</td>
            <td colspan="2">{{battery.min}}</td>
            <td colspan="2">{{battery.max - battery.min | number}}</td>
            <td></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
const sortkey = "power"
import api from "@/api";
export default {
  name: "CreateBattery",
  props: ['warrantyRanges', 'warranties', 'cells', 'activeTab', 'batteryNumber'],
  data: () => ({
    waiting: false,
    batteryStrength: "",
    userWarranty: "",
    today: "",
    createdBattery: [],
    sortedCells: "",
  }),
  filters: {
    number: function (value) {
      if (!value) return ''
      value = value.toFixed(2);
      return value;
    }
  },
  watch: {
    activeTab(val) {
      if(val === 3) {
        this.createPack();
      }
    },
    cells() {
      this.createPack();
    }
  },
  methods: {
    createPack() {
			this.batteryStrength = [];
			this.userWarranty = '';

			this.today = new Date().toDateString();


      let cellset, sortedset, sortedset1, sortedset2, combined, sortedPack;
      cellset = this.cells;
      var batteryMeta = this.$getBatteryMeta(cellset);
      // battery strength 
      this.batteryStrength = batteryMeta.batteryStrength;
      // 
      this.sortedCells = batteryMeta.sortedCells;
      sortedset = this.sortcells(cellset, 'desc');
      sortedset2 = sortedset.concat();
      sortedset1 = sortedset2.splice(0, cellset.length / 2);
      sortedset2 = this.sortcells(sortedset2, 'asc');
      combined = this.createSet(sortedset1, sortedset2);
      sortedPack = this.sortcells(combined, 'desc');
      this.createdBattery = this.arrangeBattery(sortedPack);
		},
    sortcells(set, order) {
			var result;
			if (order == "desc")
				result = set.concat().sort(this.orderPOVDesc);
			else
				result = set.concat().sort(this.orderPOVAsc);
			return result;
		},
    orderPOVDesc (a, b) {
			if (a[sortkey] > b[sortkey])
				return -1;
			if (a[sortkey] < b[sortkey])
				return 1;
			return 0;
		},
    orderPOVAsc(a, b) {
			if (a[sortkey] < b[sortkey])
				return -1;
			if (a[sortkey] > b[sortkey])
				return 1;
			return 0;
		},
    createSet (arr1, arr2) {
			var result = [];
			for (var i = 0; i < arr1.length; i++) {
				var combinedpov = parseFloat(arr1[i].voltage) + parseFloat(arr2[i].voltage);
				var module = {
					cells: [
						arr1[i], arr2[i]
					],
					voltage: combinedpov.toFixed(2)
				}
				result.push(module);
			}
			return result;
		},
    arrangeBattery(battery) {
			var arrangeBattery = [];

			for (var i = 0; i < battery.length; i++) {
				if (i % 2 == 0) {
					arrangeBattery.push(battery[i]);
				} else {
					arrangeBattery.unshift(battery[i]);
				}
			}

			return arrangeBattery;
		},
    async confirmBattery(pack) {
      try {
        this.waiting = true;
        await api.createBattery(pack);
        this.$toast.success("Battery Created SuccessFully");
        this.$router.push(`batteries`)
      } catch (error) {
        this.$toast.error("Unable to create battery");
      }
      this.waiting = false;
		}
  },
  mounted() {
    this.createPack();
  }
};
</script>